module.exports = __webpack_public_path__ + "media/10-1.554a2019.mp4";